// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Id6I","newExpiryDate":"styles_newExpiryDate__2bZz8","footer":"styles_footer__1zekn"};